import * as commonScripts from '../common'
const cmpImageLayered = {
  component: null,
  init: function (element) {
    const _ = this
    _.component = element
    commonScripts.util.animationTranslate(this)
    commonScripts.util.inheritPermalink(element)
    const contentImageLayered = _.component.querySelector('.cmp-image-layered__content')
    const layeredImage = _.component.querySelector('.cmp-image-layered__bg__img')
    const whiteDiv = _.component.querySelector('.white-div-bg')
    if (contentImageLayered) {
      function setSize () {
        const imageWidth = _.component.querySelector('.cmp-image-layered__content__media').offsetWidth
        const rect = contentImageLayered.getBoundingClientRect()
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth
        if (layeredImage) {
          if (viewportWidth >= 1920) {
            layeredImage.style.paddingLeft = (rect.left + 360) + 'px'
          } else if (viewportWidth >= 1440 && viewportWidth < 1920) {
            layeredImage.style.paddingLeft = (rect.left + 285) + 'px'
          } else if (viewportWidth >= 1024 && viewportWidth < 1440) {
            layeredImage.style.paddingLeft = (rect.left + 165) + 'px'
          } else if (viewportWidth >= 768 && viewportWidth < 1024) {
            layeredImage.style.paddingLeft = (rect.left + 120) + 'px'
          } else if (viewportWidth >= 510 && viewportWidth < 768) {
            layeredImage.style.bottom = (rect.height - 164 - (rect.width - (448 + Math.sqrt(rect.width)))) + 'px'
          } else if (viewportWidth < 510) {
            layeredImage.style.bottom = (rect.height - 164 - (rect.width - 258)) + 'px'
          }
        }
        if (viewportWidth >= 768) {
          if (layeredImage) { layeredImage.style.bottom = 0 }
          if (whiteDiv) { whiteDiv.style.paddingLeft = (imageWidth + 16) + 'px' }
        } else if (viewportWidth < 768) {
          if (layeredImage) { layeredImage.style.paddingLeft = '0px' }
          if (whiteDiv) { whiteDiv.style.paddingLeft = '0px' }
        }
      }
      window.addEventListener('resize', setSize, false)
      window.addEventListener('load', setSize, false)
      window.addEventListener('orientationchange', setSize, false)
    }
  }
}

export default cmpImageLayered
